import DatePicker from '../../../../components/Datepicker'
import Dropdown from '../../../../components/Dropdown'
import { IterateOptions } from '../../../../components/FormUtilities'
import { Option as OptionType } from '../../../../config/types/component'
import useStorage from '../../../../hooks/useStorage'
import { controlList } from '../../storage'
import { setCompanySelected } from '../../../../utilities/controlStorage'

function CompanyField() {
    const { props } = controlList.useFilter('company_id')
    const { companiesFromSession } = useStorage()

    async function handleChange(option: OptionType) {
        const company = companiesFromSession.find(
            comp => comp.id === parseInt(option.value)
        )
        setCompanySelected(company)
        props.onChange(option)
    }

    return (
        <Dropdown
            {...props}
            label="Compañía"
            clear={false}
            onChange={handleChange}
            showLabel={false}
        >
            <IterateOptions
                data={companiesFromSession.map(company => ({
                    name: company.name,
                    image_url: company.country.image_url,
                    id: company.id,
                    disabled: !company.is_enabled
                }))}
                label="name"
                image="image_url"
                strikeOut="disabled"
            />
        </Dropdown>
    )
}

function StartDateField() {
    const { value } = controlList.useParam('start_date')

    async function changeHandler(isoString: string) {
        controlList.filter.setParams('start_date', isoString)
        controlList.render('start_date')
    }

    return (
        <div className="w-64">
            <DatePicker
                value={value}
                onChange={changeHandler}
                fullWidth={false}
                minimize
                className="mt-0 mb-0"
            />
        </div>
    )
}

function EndDateField() {
    const { value } = controlList.useParam('end_date')

    async function changeHandler(isoString: string) {
        controlList.filter.setParams('end_date', isoString)
        controlList.render('end_date')
    }

    return (
        <div className="w-64">
            <DatePicker
                value={value}
                onChange={changeHandler}
                fullWidth={false}
                minimize
                className="mt-0 mb-0"
            />
        </div>
    )
}

export default function Filters() {
    return (
        <>
            <CompanyField />
            <StartDateField />
            <EndDateField />
        </>
    )
}
